class TcCleanoutWizard extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 1;
    this.totalSteps = 5;
  }

  connectedCallback() {
    this.dialogEl = this.querySelector('[data-tc-wizard-dialog]');
    this.progressEl = this.querySelector('[data-tc-wizard-progress]');
    this.stepEls = Array.from(this.querySelectorAll('[data-tc-step]'));
    this.formEl = this.querySelector('form');

    document.querySelectorAll('[data-tc-open-wizard]').forEach((btn) => {
      btn.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    });

    // Auto-open the modal on success state so the user sees the confirmation.
    // Shopify appends ?contact_posted=true after a successful contact form submit.
    // We ALSO open it server-side via Liquid (form.posted_successfully?), but
    // wire up the keyboard/scroll-lock here so the modal behaves correctly.
    const openedServerSide = this.dialogEl && this.dialogEl.hasAttribute('open');
    if (openedServerSide || window.location.search.includes('contact_posted=true')) {
      this.open();
    }

    this.querySelectorAll('[data-tc-close-wizard]').forEach((btn) => {
      btn.addEventListener('click', (e) => { e.preventDefault(); this.close(); });
    });

    this.querySelectorAll('[data-tc-step-next]').forEach((btn) => {
      btn.addEventListener('click', (e) => { e.preventDefault(); this.next(); });
    });

    this.querySelectorAll('[data-tc-step-prev]').forEach((btn) => {
      btn.addEventListener('click', (e) => { e.preventDefault(); this.prev(); });
    });

    this.querySelectorAll('[data-tc-step-jump]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = parseInt(btn.getAttribute('data-tc-step-jump'), 10);
        if (target >= 1 && target <= this.totalSteps) { this.goTo(target); }
      });
    });

    const disqualifyLink = this.querySelector('[data-tc-disqualify]');
    const disqualifyPanel = this.querySelector('[data-tc-disqualified]');
    if (disqualifyLink && disqualifyPanel) {
      disqualifyLink.addEventListener('click', (e) => {
        e.preventDefault();
        disqualifyPanel.style.display = disqualifyPanel.style.display === 'none' ? 'block' : 'none';
      });
    }

    const multiboxRadio = this.querySelector('[data-tc-show-multibox-note]');
    const multiboxNote = this.querySelector('[data-tc-multibox-note]');
    if (multiboxRadio && multiboxNote) {
      this.querySelectorAll('input[name="item_count"]').forEach((r) => {
        r.addEventListener('change', () => {
          multiboxNote.style.display = multiboxRadio.checked ? 'block' : 'none';
        });
      });
    }

    this.formEl.addEventListener('submit', (e) => {
      // Build the contact[body] payload before native submit fires.
      const fd = new FormData(this.formEl);
      const brands = fd.getAll('brands[]');
      const plushBrands = fd.getAll('brands_plush[]');
      const lines = [
        `Customer: ${fd.get('first_name')} ${fd.get('last_name')}`,
        `Email: ${fd.get('contact[email]')}`,
        `Phone: ${fd.get('phone')}`,
        `Shopify customer ID: ${window.__tc_customer_id || '(guest)'}`,
        '',
        'Brands selected:',
        ...brands.map((b) => `- ${b}`),
        ...plushBrands.map((b) => `- Plush: ${b}`),
        '',
        `Estimated items: ${fd.get('item_count')}`,
        `Condition confirmed: ${fd.get('condition_confirmed') === 'on' ? 'Yes' : 'No'}`,
        '',
        'Ship label to:',
        fd.get('address_1'),
        fd.get('address_2') || '',
        `${fd.get('city')}, ${fd.get('state')} ${fd.get('zip')}`,
        '',
        'Terms accepted:',
        fd.get('terms_tcs') === 'on' ? '✓ Seller T&Cs' : '',
        fd.get('terms_fee') === 'on' ? '✓ Label fee deducted from first payout' : '',
        fd.get('terms_donation') === 'on' ? '✓ Ineligible items donated, disposal fee may apply' : '',
        '',
        `Submitted: ${new Date().toISOString()}`,
      ];
      const bodyEl = this.querySelector('[data-tc-body]');
      if (bodyEl) { bodyEl.value = lines.join('\n'); }
      // Update the contact[subject] to include item count and brand count.
      const subjectEl = this.querySelector('input[name="contact[subject]"]');
      if (subjectEl) {
        const count = brands.length + plushBrands.length;
        subjectEl.value = `[CLEANOUT BOX REQUEST] ${fd.get('first_name')} ${fd.get('last_name')} — ${fd.get('item_count')}, ${count} brand(s)`;
      }

      // Mirror the submission to a Google Sheet via Apps Script webhook, if configured.
      // Fire-and-forget: the contact-form email is the source of truth, so we never
      // block the native submit on this call. `keepalive: true` lets the request
      // finish in the background after the page navigates to the success state.
      // `mode: 'no-cors'` + `text/plain` skips the CORS preflight, which Apps Script
      // Web App deployments don't handle by default.
      const sheetUrl = this.dataset.sheetWebhookUrl;
      if (sheetUrl) {
        const payload = {
          timestamp: new Date().toISOString(),
          sourceUrl: window.location.href,
          customerId: window.__tc_customer_id || null,
          firstName: fd.get('first_name') || '',
          lastName: fd.get('last_name') || '',
          email: fd.get('contact[email]') || '',
          phone: fd.get('phone') || '',
          brands: brands.concat(plushBrands),
          itemCount: fd.get('item_count') || '',
          conditionConfirmed: fd.get('condition_confirmed') === 'on',
          address1: fd.get('address_1') || '',
          address2: fd.get('address_2') || '',
          city: fd.get('city') || '',
          state: fd.get('state') || '',
          zip: fd.get('zip') || '',
          termsTcs: fd.get('terms_tcs') === 'on',
          termsFee: fd.get('terms_fee') === 'on',
          termsDonation: fd.get('terms_donation') === 'on',
        };
        try {
          fetch(sheetUrl, {
            method: 'POST',
            mode: 'no-cors',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify(payload),
          }).catch(() => { /* swallowed — email is the source of truth */ });
        } catch (_err) { /* same */ }
      }
    });

    this.render();
  }

  open() {
    this.dialogEl.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    this._escHandler = (e) => { if (e.key === 'Escape') this.close(); };
    document.addEventListener('keydown', this._escHandler);
    const closeBtn = this.dialogEl.querySelector('[data-tc-close-wizard]');
    if (closeBtn) { closeBtn.focus(); }
  }

  close() {
    this.dialogEl.removeAttribute('open');
    document.body.style.overflow = '';
    if (this._escHandler) {
      document.removeEventListener('keydown', this._escHandler);
      this._escHandler = null;
    }
  }

  next() {
    if (!this.validateStep(this.currentStep)) { return; }
    if (this.currentStep < this.totalSteps) {
      this.currentStep += 1;
      this.render();
    }
  }

  prev() {
    if (this.currentStep > 1) {
      this.currentStep -= 1;
      this.render();
    }
  }

  goTo(step) {
    this.currentStep = step;
    this.render();
  }

  render() {
    this.stepEls.forEach((el) => {
      const step = parseInt(el.getAttribute('data-tc-step'), 10);
      el.style.display = step === this.currentStep ? '' : 'none';
    });
    if (this.progressEl) {
      this.progressEl.textContent = `Step ${this.currentStep} of ${this.totalSteps}`;
    }
    if (this.currentStep === this.totalSteps) {
      this.populateReview();
    }
  }

  validateStep(step) {
    const stepEl = this.querySelector(`[data-tc-step="${step}"]`);
    if (!stepEl) { return true; }
    const stepError = stepEl.querySelector('[data-tc-step-error]');
    const fieldListEl = stepEl.querySelector('[data-tc-step-error-fields]');
    if (stepError) { stepError.hidden = true; }
    if (fieldListEl) { fieldListEl.textContent = ''; }
    const invalidLabels = [];
    const requiredInputs = stepEl.querySelectorAll('[data-tc-required]');
    let valid = true;
    const markInvalid = (input, suffix) => {
      this.flagError(input);
      const label = input.getAttribute('data-tc-label');
      if (label) {
        invalidLabels.push(suffix ? `${label} (${suffix})` : label);
      }
    };

    requiredInputs.forEach((input) => {
      const isCheckbox = input.type === 'checkbox';
      const isRadioGroup = input.type === 'radio';
      const isCheckboxGroup = input.hasAttribute('data-tc-checkbox-group');

      if (isCheckboxGroup) {
        const groupName = input.getAttribute('name');
        let checked = 0;
        if (groupName === 'step1_marker') {
          // Brand selector spans two groups: brands[] and brands_plush[]
          checked = stepEl.querySelectorAll('input[name="brands[]"]:checked, input[name="brands_plush[]"]:checked').length;
        } else {
          checked = stepEl.querySelectorAll(`input[name="${groupName}"]:checked`).length;
        }
        if (checked === 0) { valid = false; markInvalid(input); }
      } else if (isRadioGroup) {
        const groupName = input.getAttribute('name');
        const checked = stepEl.querySelector(`input[name="${groupName}"]:checked`);
        if (!checked) { valid = false; markInvalid(input); }
      } else if (isCheckbox) {
        if (!input.checked) { valid = false; markInvalid(input); }
      } else {
        if (!input.value.trim()) { valid = false; markInvalid(input); }
        if (input.value.trim() && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
          valid = false; markInvalid(input, 'invalid format');
        }
        if (input.hasAttribute('pattern') && input.value.trim() && !new RegExp('^(?:' + input.getAttribute('pattern') + ')$').test(input.value)) {
          valid = false; markInvalid(input, 'invalid format');
        }
        if (input.hasAttribute('data-tc-state')) {
          const excludedStates = (this.dataset.excludedStates || 'HI,AK').split(',').map(s => s.trim());
          if (excludedStates.includes(input.value)) {
            valid = false;
            this.flagError(input);
            const errorEl = this.querySelector('[data-tc-state-error]');
            if (errorEl) { errorEl.style.display = 'block'; }
          } else {
            const errorEl = this.querySelector('[data-tc-state-error]');
            if (errorEl) { errorEl.style.display = 'none'; }
          }
        }
      }
    });
    if (!valid && stepError) {
      stepError.hidden = false;
      // Dedupe in case the same field hit multiple validators
      const unique = Array.from(new Set(invalidLabels));
      if (fieldListEl && unique.length > 0) {
        fieldListEl.textContent = unique.join(', ');
      }
      // Scroll the banner into view so the user sees the message immediately
      if (typeof stepError.scrollIntoView === 'function') {
        stepError.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    return valid;
  }

  flagError(input) {
    input.classList.add('tc-input--error');
    input.addEventListener('input', () => input.classList.remove('tc-input--error'), { once: true });
    input.addEventListener('change', () => input.classList.remove('tc-input--error'), { once: true });
  }

  populateReview() {
    const reviewEl = this.querySelector('[data-tc-review]');
    if (!reviewEl) { return; }
    const fd = new FormData(this.formEl);
    const brands = fd.getAll('brands[]').concat(fd.getAll('brands_plush[]'));
    const data = {
      brands: brands.length ? brands.join(', ') : '(none)',
      itemCount: fd.get('item_count') || '(not set)',
      conditionConfirmed: fd.get('condition_confirmed') === 'on' ? 'Yes' : 'No',
      firstName: fd.get('first_name') || '',
      lastName: fd.get('last_name') || '',
      email: fd.get('contact[email]') || '',
      phone: fd.get('phone') || '',
      address: [fd.get('address_1'), fd.get('address_2'), `${fd.get('city') || ''}, ${fd.get('state') || ''} ${fd.get('zip') || ''}`].filter(Boolean).join(' / '),
    };
    reviewEl.querySelectorAll('[data-tc-review-field]').forEach((el) => {
      const key = el.getAttribute('data-tc-review-field');
      el.textContent = data[key] || '';
    });
  }
}

customElements.define('tc-cleanout-wizard', TcCleanoutWizard);
